var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.00004C2 3.63185 2.29848 3.33337 2.66667 3.33337H13.3333C13.7015 3.33337 14 3.63185 14 4.00004C14 4.36823 13.7015 4.66671 13.3333 4.66671H2.66667C2.29848 4.66671 2 4.36823 2 4.00004ZM10 8.00004C8.89543 8.00004 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8.00004 10 8.00004ZM6.66667 10C6.66667 8.15909 8.15905 6.66671 10 6.66671C11.8409 6.66671 13.3333 8.15909 13.3333 10C13.3333 10.6797 13.1299 11.3119 12.7806 11.839C12.7888 11.8464 12.7968 11.8541 12.8047 11.862L14.4714 13.5286C14.7318 13.789 14.7318 14.2111 14.4714 14.4714C14.2111 14.7318 13.7889 14.7318 13.5286 14.4714L11.8619 12.8048C11.854 12.7969 11.8464 12.7888 11.839 12.7806C11.3119 13.1299 10.6797 13.3334 10 13.3334C8.15905 13.3334 6.66667 11.841 6.66667 10ZM2 8.00004C2 7.63185 2.29848 7.33337 2.66667 7.33337H5.33333C5.70152 7.33337 6 7.63185 6 8.00004C6 8.36823 5.70152 8.66671 5.33333 8.66671H2.66667C2.29848 8.66671 2 8.36823 2 8.00004ZM2 12C2 11.6319 2.29848 11.3334 2.66667 11.3334H5.33333C5.70152 11.3334 6 11.6319 6 12C6 12.3682 5.70152 12.6667 5.33333 12.6667H2.66667C2.29848 12.6667 2 12.3682 2 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.935c8b2f428bc30f099c27947fce10bb.svg";
export { ForwardRef as ReactComponent };